export class Bank {
  constructor({ $api }) {
    this.api = $api;
  }

  getAll() {
    return this.api.dispatch('bank/getAll');
  }
}

export default (ctx, inject) => {
  inject('bank', new Bank(ctx));
};
